import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { workspaceEntries } from '../config/workspaceNavigation'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      shell: false
    }
  },
  ...workspaceEntries.map(entry => ({
    path: entry.to,
    name: entry.name,
    component: entry.component,
    meta: {
      shell: true,
      title: entry.title,
      navTitle: entry.navTitle,
      groupId: entry.groupId,
      groupLabel: entry.groupLabel,
      code: entry.code
    }
  })),
  {
    path: '/emotion-demo',
    name: 'EmotionAppDemo',
    component: () => import(/* webpackChunkName: "prototype-emotion" */ '../views/EmotionAppDemo.vue'),
    meta: {
      shell: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 有保存的位置（浏览器前进/后退）则恢复，否则滚到顶部
    if (savedPosition) return savedPosition
    // 带 hash 锚点则滚到锚点
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    // 默认始终从顶部开始
    return { top: 0 }
  }
})

export default router
